var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"z-index":"-1"},style:(_vm.styleInfo),attrs:{"className":"main-shadow"}})}
var staticRenderFns = []

export { render, staticRenderFns }